import { BaseModel } from "sjs-base-model";

export default class IntegrationModel extends BaseModel {
    readonly idIntegration: number = 0;
    readonly totp: string = "";
    readonly data: string = "";
    readonly creationDate: string = "";
    readonly origin: string = "";

    constructor(data: Partial<IntegrationModel>) {
        super();

        this.update(data);
    }
}
